import { render, staticRenderFns } from "./topicsAssigned.vue?vue&type=template&id=4c3a0d3a&scoped=true&"
import script from "./topicsAssigned.vue?vue&type=script&lang=js&"
export * from "./topicsAssigned.vue?vue&type=script&lang=js&"
import style0 from "./topicsAssigned.vue?vue&type=style&index=0&id=4c3a0d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a0d3a",
  null
  
)

export default component.exports